import { Component, DestroyRef, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { API, CampaignTypeDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-campaign-type-edit',
  templateUrl: './campaign-type-edit.component.html',
  styleUrls: ['./campaign-type-edit.component.scss'],
  standalone: false,
})
export class CampaignTypeEditComponent implements OnInit {
  loading: boolean = true;

  itemId: number;

  debounceTimer: ReturnType<typeof setTimeout> = null;

  item: CampaignTypeDTO;

  editmode: boolean;

  form = new UntypedFormGroup({
    Name: new UntypedFormControl('', [Validators.required]),
    Description: new UntypedFormControl('', []),
  });

  get Name() {
    return this.form.get('Name');
  }

  get Description() {
    return this.form.get('Description');
  }

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    private errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.loading = true;

    this.activatedRoute.params.subscribe(params => {
      this.itemId = +params.campaignTypeID;
      if (this.itemId) {
        this.editmode = true;

        this.requestDebounced();
      } else {
        this.editmode = false;

        this.item = this.api.createDTO('CampaignTypeDTO');

        this.loading = false;
      }
    });
  }

  requestDebounced() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    this.api
      .ca_md_CampaignType_retrieveById(this.itemId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: data => {
          this.item = data;
          this.refreshFormFromDTO();
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
  }

  refreshFormFromDTO() {
    this.Name.setValue(this.item.name);
    this.Description.setValue(this.item.description);
  }

  refreshDTOFromForm() {
    this.item.name = this.Name.value;
    this.item.description = this.Description.value;
  }

  submit() {
    this.loading = true;
    this.refreshDTOFromForm();

    let obs: Observable<CampaignTypeDTO>;

    if (this.editmode) {
      obs = this.api.ca_md_CampaignType_edit(this.item);
    } else {
      obs = this.api.ca_md_CampaignType_create(this.item);
    }

    if (obs) {
      obs
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: data => {
            this.item = data;

            this.refreshFormFromDTO();

            this.util.returnToNavigation(this.util.RoutingID.campaignTypes);
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  cancel() {
    this.util.returnToNavigation(this.util.RoutingID.campaignTypes);
  }
}
